module.exports = __webpack_public_path__ + "static/media/dark-u.98109e3f.png";